module.exports = __webpack_public_path__ + "img/IsCallRequested.4563264e.svg";